import { environment } from './../../../environments/environment';
import { DataService } from './../data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { AddOnBusinessAccountRequest } from 'src/app/models/add-on-business-account-request';
import { AddOnAccountData } from 'src/app/models/add-on-account-data';
import { AccountSettings } from 'src/app/models/account-settings';
import { catchError, map } from 'rxjs';


@Injectable()
export class AddonBusinessService {
  csvRecords = [];
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }

  AddBusinessAcc(data, email) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.newBusinessAccUrl + "?email=" + email, data, { headers: this.headers });
  }
  AddAccSettings(data, email) {
    this.GetHeaderdetails();
    return this.http.post(environment.newAccSettingsUrl + "?email=" + email, data, { headers: this.headers });
  }
  addOnBusinessAccountData(data, email) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.createBusinessAccountDataUrl + "?email=" + email, data, { headers: this.headers });
  }

  InsertItem(id,MerchantKeyid,data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post(environment.BusinessProFileItemFileUplod + "?Id=" +id+"&MerchantKeyid="+MerchantKeyid+"&LoginUserId="+merchantdata.UserId,data,{headers:this.headers});
  
  }

  GetAccountsList(data, email) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<AddOnBusinessAccountRequest>(environment.accountsListUrl + "?MerchantKeyId=" + data + "&email=" + email + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  getAccountDatasList(data, email) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<AddOnAccountData>(environment.accountDatasListUrl + "?merchantKeyId=" + data.MerchantKeyId + "&businessId=" + data.BusinessAccountId + "&email=" + email + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  // getAcountDetails(data)
  // {
  //  return this.http.get(environment.viewBusinessAccUrl+"?id="+data.id+"&emailUserName="+data.emailUserName)
  //   .map(response => response) .catch(this.common.handleError);
  // }  
  getAcountDetails(data, emailUserName) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<AddOnBusinessAccountRequest>(environment.viewBusinessAccUrl + "?id=" + data + "&email=" + emailUserName + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }


  checkDuplicteAccountTypes(data) {
    // return this.http.get<AddOnBusinessAccountRequest>(environment.checkAccountTypesListUrl+"?MerchantKeyId="+data.MerchantKeyId+"&EmailUsername="+data.EmailUserName+"&Type="+data.Type+"&SubType="+data.SubType)  
    // .map(response => response).catch(this.common.handleError);
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<boolean>(environment.checkAccountTypesListUrl + "?MerchantKeyId=" + data.MerchantKeyId + "&EmailUsername=" + data.EmailUserName + "&Type=" + data.Type + "&SubType=" + data.SubType + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  checkDuplicteAccounts(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<boolean>(environment.checkDuplicateAccountUrl + "?MerchantKeyId=" + data.MerchantKeyId + "&EmailUsername=" + data.EmailUserName + "&Type=" + data.Type + "&SubType=" + data.SubType + "&Location=" + data.Location + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  checkDuplicteAccountsWithBName(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<boolean>(environment.checkDuplicateAccountsWithBNameUrl + "?MerchantKeyId=" + data.MerchantKeyId + "&EmailUsername=" + data.EmailUserName + "&Type=" + data.Type + "&SubType=" + data.SubType + "&Location=" + data.Location + "&BusinessName=" + data.BusinessName + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  updateBusinessAccount(data, emailUserName) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateBusinessAccountUrl + '?email=' + emailUserName, data, { headers: this.headers });

  }
  deleteBusinessAccount(data, emailUserName) {
    this.GetHeaderdetails();
    return this.http.put(environment.deleteBusinessAccountUrl + '?email=' + emailUserName, data, { headers: this.headers });

  }

  updateBusinessAccountData(data, emailUserName) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateBusinessAccountDataUrl + '?email=' + emailUserName, data, { headers: this.headers });
  }
  ViewBusinessAccount(data, email, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<AddOnBusinessAccountRequest>(environment.viewBusinessAccUrl + "?id=" + data + "&email=" + email + "&MerchantKeyId=" + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  ViewBusinessAccountData(data, email, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<AddOnAccountData>(environment.viewBusinessAccountDataUrl + "?id=" + data + "&email=" + email + "&MerchantKeyId=" + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }


  getBusinessAccountId(data, email, MerchantKeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<AccountSettings>(environment.viewAccountSettingUrl + "?id=" + data + "&email=" + email + "&MerchantKeyid=" + MerchantKeyid + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  updateAccSettings(data, email) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateAccountSettingUrl + '?email=' + email, data, { headers: this.headers });

  }
  FileUpload(data, email, businessId, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post(environment.uploadFileUrl + '?email=' + email + '&businessId=' + businessId + '&merchantKeyId=' + merchantKeyId + "&LoginUserId=" + merchantdata.UserId, data
      , { headers: this.headers });
  }
  deleteAccountData(data, userEmail) {
    this.GetHeaderdetails();
    return this.http.put(environment.deleteAccountDataUrl + '?email=' + userEmail, data, { headers: this.headers });
  }


  accountsListUrl(MerchantKeyId, Email) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.accountsListUrl + "?MerchantKeyId=" + MerchantKeyId + "&userId=" + Email + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  EasycollectFilterdataurl(MerchantKeyId, Fromdate1, todate1, Email, Type, businessname, website, loggedinuseremail) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.EasycollectFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&Email=" + Email
      + "&Type=" + Type + "&Name=" + businessname + "&Website=" + website + "&LoggedinUserEmail=" + loggedinuseremail + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }

  accountDatasListUrl(MerchantKeyId, id, emailUserName) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.accountDatasListUrl + "?merchantKeyId=" + MerchantKeyId + "&businessId=" + id + "&email=" + emailUserName + "&LoginUserId=" + merchantdata.UserId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  // req.open('GET', environment.accountDatasListUrl + "?merchantKeyId=" + merchantdata.MerchantKeyId + "&businessId=" + this.id + "&email=" + this.emailUserName);

  Zipcodedetails(Zipcode, Merchantkeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.Zipcodedetailsurl + "?Zipcode=" + Zipcode + "&Merchantkeyid=" + Merchantkeyid+ "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  AddCategoryType(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.AddBusinesscategory, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetCategoryType(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.GetCategoryType, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetType(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.GetType, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetSubType(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.GetSubType, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  AddSubCategoryType(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.AddSubCategoryType, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

  }
}
